var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#214a92",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {},
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,4l-1.492,0c-1.938,0 -3.508,1.57 -3.508,3.508l0,19.984c0,0.931 0.37,1.823 1.027,2.481c0.658,0.657 1.55,1.027 2.481,1.027c5.769,-0 19.492,-0 19.492,-0l0.025,-0c0.173,-0.005 0.336,-0.053 0.477,-0.135l0.017,-0.01c0.068,-0.041 0.131,-0.091 0.188,-0.148l6,-6c0.057,-0.057 0.107,-0.12 0.148,-0.188l0.01,-0.017c0.082,-0.141 0.13,-0.304 0.135,-0.477l0,-0.025l0,-16.492c-0,-1.938 -1.57,-3.508 -3.508,-3.508l-1.492,0l0,-1c0,-1.104 -0.896,-2 -2,-2c0,0 -2,0 -2,0c-1.104,0 -2,0.896 -2,2l0,1l-1,0l0,-1c0,-1.104 -0.896,-2 -2,-2c0,0 -2,0 -2,0c-1.104,0 -2,0.896 -2,2l0,1l-1,0l0,-1c0,-1.104 -0.896,-2 -2,-2c0,0 -2,0 -2,0c-1.104,0 -2,0.896 -2,2l0,1Zm23,19l0,-10l-26,0c0,0 0,14.492 0,14.492c0,0.4 0.159,0.784 0.442,1.066c0.282,0.283 0.666,0.442 1.066,0.442l18.492,-0l0,-5c0,-0.552 0.448,-1 1,-1l5,0Zm-4,2l0,2.586l2.586,-2.586l-2.586,0Zm-3,-19l0,2c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-1.104,0 -2,-0.896 -2,-2l0,-2l-5,0l0,2c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-1.104,0 -2,-0.896 -2,-2l0,-2l-5,0l0,2c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-1.104,0 -2,-0.896 -2,-2l0,-2l-1.492,0c-0.833,0 -1.508,0.675 -1.508,1.508l-0,3.492l26,-0l-0,-3.492c-0,-0.833 -0.675,-1.508 -1.508,-1.508l-5.492,0Zm2,-2l0,-1c0,0 -2,0 -2,0l0,1l2,0Zm-7,0l0,-1c0,0 -2,0 -2,0l0,1l2,0Zm-7,0l0,-1c0,0 -2,0 -2,0l0,1l2,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.de439cd1a538200ce6db58c418e2ef41.svg";
export { ForwardRef as ReactComponent };